import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, from} from "rxjs";
 
import {Subscription} from "rxjs"; 
import {delay, map, switchMap} from 'rxjs/operators';
import {ActivatedRoute, Params, Router} from '@angular/router';
import * as moment from 'moment';
import { Socket } from 'ngx-socket-io';
import {AnalyticService} from '../shared/services/analytic.service'
import { NbDialogService, NbToastrService, NbGlobalPosition } from '@nebular/theme';
import {StatModalKeysComponent} from '../shared/components/stat-modal-keys/stat-modal-keys.component'
 import {domain, protocol} from '../shared/config';
 
@Component({
  selector: 'app-public-stat-page', 
  templateUrl: './public-stat-page.component.html',
  styleUrls: ['./public-stat-page.component.scss'],
  
})
export class PublicStatPageComponent implements OnInit, OnDestroy, AfterViewInit{
 
    lSub$:any;
	  domain: any = {
    name: domain, protocol
  }
  togglePublish$:any;
    stat:any;
    stat_id:string;
stream_id:string;
   openLink:string;
  loading:boolean = true;
  publishDisabled = false

  constructor(      private toastrService: NbToastrService,
     private dialogService: NbDialogService, 
	 private analyticService: AnalyticService,
	 public route:  ActivatedRoute,
	  private router: Router
   ){
  }
   
 
   ngOnInit() { 


	
 	this.lSub$ = this.route.params.pipe(
      switchMap((params: Params)=>{
        	this.stat_id = params['id']
        return this.analyticService.getPublihsStat(this.stat_id).pipe(
          map((stat: any)=>{
 
 
	    this.stat =stat
	   this.loading = false
           this.stream_id = this.stat.stream_id
	 this.openLink = `${this.domain.protocol}${this.domain.name}/stat/${stat.privateLink}`
            return stat
          })
        )
      })
    ).subscribe(()=>{},(err)=>{
		this.router.navigate(['/channel'])
				return

	})
 
	 
 
  }

   

 



 refresh(){

	if(this.lSub$){
		this.lSub$.unsubscribe()
	}
		this.loading = true
	this.lSub$ =   this.analyticService.getPublihsStat(this.stat_id).subscribe( (stat: any)=>{
 
	    this.stat = stat
	   this.loading = false
            
          },(err)=>{
		this.router.navigate(['/channel'])
				return

	})
         
}
 


  
   ngAfterViewInit() {
 
   }
 
   ngOnDestroy() {
   	if(this.lSub$){
		this.lSub$.unsubscribe()
	}
	if(this.togglePublish$){
		this.togglePublish$.unsubscribe()
	}

	
   }
 
 



   openKeysModal(){
 
    this.dialogService.open(StatModalKeysComponent, {
      dialogClass: 'settings-modalsscrollable-container',
      context: {
        stat_id: this.stat_id,
	pub: true
      },
    });


   }
   
/**/
 
  
}
